import { Box, Link, Typography } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { EmptyMatchedStateIcon } from '../../../../../../components/icons'
import { AppDispatch } from '../../../../../../store'
import { TechGrantsActions, TechGrantSelectors } from '../../../../../../store/technology'
import { MetricsActions } from '../../../../../../store/TechnologyMetrics'
import { EmptyState, GrantsTable } from '../../sharedComponents'

const Table_Headers = [
  'Grant Name',
  'Funding Agency',
  'Amount',
  'Type',
  'Due Date',
  'Accept/Reject',
]

export const MatchedGrants: React.FC = () => {
  const { projectId = '' } = useParams()

  const dispatch = useDispatch<AppDispatch>()

  const paging = useSelector(TechGrantSelectors.getPaging)
  const grants = useSelector(TechGrantSelectors.makeMatchedGrants)

  const fetchGrants = useCallback(() => {
    if (projectId) {
      const options = {
        params: {
          $limit: paging.limit,
          $skip: paging.skip,
          $sort: `createdAt -1`,
          $includes: 'grant,solicitation',
          $filter: JSON.stringify({
            status: 'recommended',
          }),
        },
      }

      dispatch(
        TechGrantsActions.fetchGrantsAsync({
          id: projectId,
          options,
        }),
      )

      dispatch(MetricsActions.fetchTechnologyMetricsAsync({ techId: projectId }))
    }
  }, [paging.limit, paging.skip, projectId, dispatch])

  useEffect(() => {
    fetchGrants()
  }, [fetchGrants])

  const EmptyComponent = (
    <EmptyState
      message={
        <>
          You currently don't have any new matched recommendations. Please check back later for new
          matches, or <Link href="/browse">browse</Link> open grants now!
        </>
      }
      icon={EmptyMatchedStateIcon}
    />
  )

  return (
    <Box mt={3}>
      <Typography color='secondary' fontSize='1rem' fontWeight={600}>Grants</Typography>

      <GrantsTable
        grants={grants}
        paging={paging}
        currentTab="Matches"
        projectId={projectId}
        fetchGrants={fetchGrants}
        tableHeader={Table_Headers}
        emptyComponent={EmptyComponent}
      />
    </Box>
  )
}
